<template>
  <div v-if="memberData.id==null">    
    <a href="/login"><b-button variant="primary" class="float-button"> <i class="fas fa-id-card"></i> Become a Member</b-button></a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      memberData: localStorage.getItem("member") ? JSON.parse(localStorage.getItem("member")) : {},
    };
  },
};
</script>

<style scoped>
.float-button {
  position: fixed;
  bottom: 20px;
  right: 15px;
  z-index: 1000; /* Ensure button is above other content */
}
</style>